import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "styled-components";
import { ToastContainer } from "react-toastify";
import { ReduxProvider } from "./lib/redux/ReduxProvider";
import theme from "./theme/theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <ToastContainer />
      <ReduxProvider>
        <App />
      </ReduxProvider>
    </ThemeProvider>
  </React.StrictMode>
);
